// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAHc7sqdSFX71mxSN_drLpbg-R6B77gLXk',
    authDomain: 'buildingcloud-ai.firebaseapp.com',
    databaseURL: 'https://buildingcloud-ai-default-rtdb.firebaseio.com',
    projectId: 'buildingcloud-ai',
    storageBucket: 'buildingcloud-ai.appspot.com',
    messagingSenderId: '665605493646',
    appId: '1:665605493646:web:ee00fbf38c93fbd3824adf',
    measurementId: 'G-T6G7WRB9T6'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
